import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../reducers";
import { bindActionCreators } from "redux";
import * as action from '../actions/monitor';
import { useRouter } from "../../helpers/customHooks";
import { Monitor, Monitors } from "../../components/Monitor/types";

export const useMonitorState = () => {
  const monitor = useSelector((state: RootState) => state.monitorData) as Monitors;
  return { ...monitor };
};

type Match = { day: number, month: number, year: number }

export const useMonitorDispatch = () => {
  const { match } = useRouter();
  const dispatch = useDispatch();
  const { day, year, month } = match.params as Match;

  return { 
    ...bindActionCreators({ ...action }, dispatch),
    getMonitorData: () => {
      dispatch(action.getMonitorData(new Date(year, month - 1, day).getTime()));
    },
    checkReviewMonitor: (data: Monitor) => {
      dispatch(action.checkReviewMonitor(data, year, month, day));
    }
  };
};